import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../../assets/Logo.png";

const useStyle = makeStyles(() => ({
  logo: {
    width: 200,
    marginTop: 16,
  },
}));

const KLogo = () => {
  const classes = useStyle();

  return (
    <div style={{ textAlign: "center" }}>
      <img src={logo} className={classes.logo} alt="KYBURZ Logo" />
    </div>
  );
};

export default KLogo;
